module.exports = __webpack_public_path__ + "img/contactImg1.773b5230.png";